module.exports = __webpack_public_path__ + "img/event.db2db1c4.png";